export default __webpack_public_path__ + "static/media/Proxima Nova Regular.e3143307.ttf";